import React, { useEffect, useRef, useState } from 'react';
import { Microphone, MICOFF, FullScreen, close} from '../../../../assets/icons';
import ProductsListing from '../productsListingFullScreen';
import { useDispatch } from 'react-redux';
import { setStramState } from '../../../live-main/livemain.actions';
import { setCopresenterMuteUid } from '../streamControls/controls.actions';
import useAppAccessor from '../../../../hooks/useappAccessor';
import { getBrandColor } from '../../../../utils/brand.util';


export const VideoPlayer = ({
  user,
  width,
  height,
  showInfo,
  num,
  isTwo,
  isOne,
  showExampleVideo = false,
  videoFit = 'cover',
  canPin = false,
  isPinned = false,
  onTogglePin,
}) => {
  const ref = useRef();
  const videoRef = useRef(null);
  const [hostName, setHostName] = useState('');
  const dispatch = useDispatch();
  const { getLiveMainData, getControls, getUserData } = useAppAccessor();
  const { configurationData, joinData, attendeeList } = getLiveMainData();
  const { isScreenSharing } = getControls();
  const { client } = getUserData();

  // useEffect(() => {
  //   // console.log(
  //   //   '%c📹 VideoPlayer User Data',
  //   //   'background: #4CAF50; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold; font-size: 12px;'
  //   // );
  //   // console.table({
  //   //   uid: user?.uid || 'N/A',
  //   //   firstName: user?.firstName || 'N/A',
  //   //   lastName: user?.lastName || 'N/A',
  //   //   isCameraOn: user?.isCameraOn ? '✅ true' : '❌ false',
  //   //   isMicOn: user?.isMicOn ? '✅ true' : '❌ false',
  //   //   isScreenSharing: user?.isScreenSharing ? '✅ true' : '❌ false',
  //   //   hasVideoTrack: user?.videoTrack ? '✅ yes' : '❌ no',
  //   //   hasAudioTrack: user?.audioTrack ? '✅ yes' : '❌ no',
  //   //   rotateDegree: user?.rotateDegree ?? 0,
  //   //   timestamp: user?.timestamp ? new Date(user.timestamp).toLocaleTimeString() : 'N/A',
  //   //   streamId: user?.videoTrack?.streamId || 'N/A',
  //   // });
  //   // console.log('%cFull User Object:', 'color: #2196F3; font-weight: bold;', user);
  // }, [user]);

  const isMobile =
  window.innerWidth < 768 ||
  /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  const getUserInitials = () => {
    if (user?.firstName && user?.lastName) {
      const firstInitial = Array.from(user.firstName)[0] || '';
      const lastInitial = Array.from(user.lastName)[0] || '';
      return (lastInitial + firstInitial).toUpperCase();
    }
    return 'N/A';
  };

  useEffect(() => {
    if (!user.videoTrack || !ref.current) {
      return;
    }

    const shouldPlayVideo = user.isCameraOn || user.isScreenSharing;
    if (shouldPlayVideo) {
      const fit = videoFit === 'unset' ? 'cover' : videoFit;
      user.videoTrack.play(ref.current, { mirror: false, fit: fit || 'cover' });
    } else {
      try {
        user.videoTrack.stop();
      } catch (error) {
        console.warn('[VideoPlayer] Error stopping video track:', error);
      }
    }
  }, [user.isCameraOn, user.isScreenSharing, user.videoTrack, videoFit]);

  useEffect(() => {
    // Legacy code - kept for reference
  }, []);



  const toggleFullScreen = () => {
    var elem = document.getElementById("shsh"+num);
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
    }
    }
  }


  useEffect(() => {
    if (joinData && joinData.attendees) {
      for (var i = 0; i < joinData.attendees.length; i++) {
       if(joinData.attendees[i].role == 'host'){
        setHostName(joinData.attendees[i].givenName+" "+joinData.attendees[i].familyName);
       }
      }
    }
  });

  useEffect(() => {
    dispatch(setStramState('started'));

    const intervalId = setInterval(() => {
      if (!user.videoTrack) {
        return;
      }

      var id = 'shsh'+num;
      const element = document.getElementById(id);
      if (element) {
        const divs = element.getElementsByTagName('div');
        var num1 = 0;
        for (var i = 0; i < divs.length; i++) {
          if (divs[i].id.lastIndexOf('agora') > -1) {
            num1++;
          }
        }
        if (num1 > 1) {
          var first = true;
          for (var i = divs.length - 1; i >= 0; i--) {
            if (divs[i].id.lastIndexOf('agora-video-player') > -1) {
              divs[i].style.display = first ? 'block' : 'none';
              first = false;
            }
          }
        }
      }

      // find all <video>,set borderRadius to 9px
      var videos = document.getElementsByTagName('video');
      if (videos.length > 1) {
        for (var i = 0; i < videos.length; i++) {
          videos[i].style.borderRadius = '9px';
          videos[i].parentNode.style.backgroundColor = 'transparent';
        }
      }
    }, 500);
    
    return () => clearInterval(intervalId);
  }, [user.videoTrack, num, dispatch]);

  useEffect(() => {
    if (!user.rotateDegree) return;
    
    const id = 'shsh' + num;
    const element = document.getElementById(id);
    if (!element) return;
    const videos = element.querySelectorAll('div[id*="agora"] video');
    videos.forEach(video => {
      video.style.transform = `rotate(${user.rotateDegree}deg)`;
    });
    if (videoRef.current) {
      videoRef.current.style.transform = `rotate(${user.rotateDegree}deg)`;
    }
  }, [user.rotateDegree]);

  useEffect(() => {
    if (!user.videoTrack && videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log('Video autoplay failed:', err);
      });
    }
  }, [user.videoTrack]);


  return (
    <div>
      {/* Uid: {user.uid} */}
      <div
        ref={ref}
        id={"shsh"+num}
        style={{ 
          height: height, 
          width: width - (isTwo ? 100 : 0), 
          position:'relative', 
          margin: isOne ? 0 : isTwo ? '2px 50px 2px 50px' : '2px 6px 2px 6px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
        }}
      >
                  {document.fullscreenElement && (
            <>
              {(
                <div className="ml-3 containerParent" style={{position: 'absolute', top:'15px', right:'0px', zIndex: 1, width: '100%'}}>
                  <div className="mt-3 overflow-x-auto w-full containerproductList pb-2 pt-2">
                    <ProductsListing></ProductsListing>
                  </div>
                </div>
              )}
            </>
          )}

      {
          document.fullscreenElement &&
          <div onClick={toggleFullScreen} style={{position: 'absolute', top:'35px', right:'15px', transform:'translate(-50%, -50%)', zIndex: 100}} className="flex items-center justify-center">
            <div className="rounded-full flex items-center justify-center text-white bg-black" style={{height:'100%', width: '100%'}}>
              <img
                src={close}
                alt="close"
                height={24}
                width={24}
                style={{ height: "24px" , margin: '3px' }}
                // className="cursor-pointer"
              ></img>
            </div>
            </div>
        }

        {
          !document.fullscreenElement && videoFit == 'contain' &&
          <div onClick={toggleFullScreen} style={isMobile ? {'opacity':0, zIndex:-32, display:'none'} : {position: 'absolute', bottom:'15px', right:'0px', zIndex: 100}} className="flex items-center justify-center">
            <div 
            id={hostName && user?.lastName && user?.firstName && hostName.trim() === (user.lastName + ' ' + user.firstName).trim() ? 'fullScreenHost' : 'fullScreenGuest'}
            className="rounded-full flex items-center justify-center text-white bg-black" style={{height:'0%', width: '0%'}}>
              <img
                id={'fullScreen'}
                src={FullScreen}
                alt="camera"
                height={24}
                width={24}
                style={{ height: "24px" , margin: '3px' }}
                // className="cursor-pointer"
              ></img>
            </div>
            </div>
        }
      {
        showInfo &&
                <div style={{zIndex:2, backgroundColor:'rgba(32, 32, 33, 0.5)', height:'20px', fontSize:'10px'}} class="absolute top-1 left-3 bg-black rounded-full flex items-center justify-center">
                 <span class="text-white ml-2 mr-2 mt-2 mb-2" style={{fontSize:'10px', cursor:'default'}}>{user?.lastName && user?.firstName ? `${user.lastName} ${Array.from(user.firstName)[0] || ''}.` : 'N/A'}</span>
                </div>
      }
      {
        showExampleVideo && !user.videoTrack && (
          <video
            ref={videoRef}
            // src={}
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              borderRadius: '9px',
              zIndex: 0
            }}
          />
        )
      }
      {
        !user.isCameraOn && !user.isScreenSharing && (
          <div 
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              backgroundColor: getBrandColor(client),
              zIndex: 1,
              height: '100%',
              width: '100%',
              borderRadius: '9px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            className="flex items-center justify-center"
          >
            <span 
              className="text-white font-semibold"
              style={{
                fontSize: Math.min(width, height) * 0.15 + 'px',
                fontWeight: 600
              }}
            >
              {getUserInitials()}
            </span>
          </div>
        )
      }
      {
        videoFit == 'contain' || ((user.isCameraOn) && videoFit != 'unset') ? null : <div style={{position:'absolute',top:0, left:0, backgroundColor:'#373737',zIndex: 0, height:'100%', width: '100%', borderRadius:'9px'}} className="flex items-center justify-center"></div>
      }
      {(showInfo || (canPin && typeof onTogglePin === 'function')) && (
        <div
          style={{
            zIndex: 9999,
            position: 'absolute',
            top: '8px',
            right: '8px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '6px',
            pointerEvents: 'none',
          }}
        >
          {showInfo && (
            <div
              id={user.uid}
              onClick={() => {
                if (window.location.href.indexOf("/stream") > -1) { // only host can mute
                  if (user.isMicOn) {
                    dispatch(setCopresenterMuteUid(user.uid));
                    setTimeout(() => {
                      dispatch(setCopresenterMuteUid(''));
                    }, 100);
                  }
                }
              }}
              className="flex items-center justify-center"
              style={{ pointerEvents: 'auto' }}
            >
              <div className="rounded-full flex items-center justify-center text-white bg-black" style={{ height: '100%', width: '100%' }}>
                <img
                  src={user.isMicOn ? Microphone : MICOFF}
                  alt="camera"
                  height={12}
                  width={12}
                  style={{ height: '12px', margin: '3px' }}
                ></img>
              </div>
            </div>
          )}
          {canPin && typeof onTogglePin === 'function' && (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onTogglePin(user.uid);
              }}
              aria-label={isPinned ? 'Unpin presenter' : 'Pin presenter'}
              style={{
                border: 'none',
                borderRadius: 9999,
                width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
                position: 'relative',
                zIndex: 1,
                cursor: 'pointer',
                pointerEvents: 'auto',
                color: isPinned ? '#111827' : '#F9FAFB',
                backgroundColor: isPinned ? '#FBBF24' : 'rgba(17,24,39,0.75)',
              }}
              title={isPinned ? 'Unpin presenter' : 'Pin presenter'}
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                transform="rotate(0)"
                aria-hidden="true"
                style={{ display: 'block', pointerEvents: 'none', cursor: 'inherit' }}
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <title>location-pin-solid</title>
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="invisible_box" data-name="invisible box">
                      <rect width="48" height="48" fill="none"></rect>
                    </g>
                    <g id="icons_Q2" data-name="icons Q2">
                      <path d="M24,4a12,12,0,0,0-2,23.8V42a2,2,0,0,0,4,0V27.8A12,12,0,0,0,24,4Zm0,16a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          )}
        </div>
      )}
      </div>
      
    </div>
  );
};
